module.exports = "https://product-cdn.sandbox.surfline.com/kbyg/_next/static/images/paywall-travel-forecaster-report-4ac828fac3cf247b5d4649e6b2872db5.png";